module.exports = __webpack_public_path__ + "r-v3/img/sticker_10.12152023.svg";